import React from 'react';
import { GetBoxes_getBoxes_boxDetails as BoxDetails } from '../../../types/schemaTypes';
import { Table } from 'react-bootstrap';
import './Inventory.scss';

interface InventoryDataProps {
    rowName: string;
    b: BoxDetails[] | number;
    t: BoxDetails[] | number;
}

interface ProppantLegendsProps {
    title: string;
    color: string;
}

export interface PrintInventoryProps {
    jobName: string;
    inventoryData: InventoryDataProps[] | undefined;
    columnNames: number[];
    proppantLegends: ProppantLegendsProps[];
    innerRef?: React.RefObject<HTMLDivElement | null>;
}

export class InventoryLayout extends React.Component<PrintInventoryProps> {
    public render() {
        const { jobName, inventoryData, columnNames, proppantLegends, innerRef } = this.props;

        if (!inventoryData) {
            return (
                <div className="NoResult-Container Inventory-Print-NoData" ref={innerRef}>
                    <div className="NoResult-First-Title-Secondary">No Data</div>
                </div>
            );
        }

        return (
            <div ref={innerRef}>
                <div className="Inventory-Header-Text">Wellhead: {jobName}</div>

                <Table className="tables Inventory-Table Inventory-Table-To-Print" bordered>
                    <thead>
                        <tr>
                            <th className="Inventory-Column" colSpan={2}></th>
                            {columnNames.map((columnName, index) => (
                                <th
                                    className={`${
                                        index === columnNames.length - 1
                                            ? 'Inventory-Column Inventory-RightBorder'
                                            : 'Inventory-Column'
                                    }`}
                                    key={index}
                                >
                                    {columnName}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {inventoryData.map((inventoryDataItem, rowIndex) => (
                            <>
                                <tr key={rowIndex}>
                                    <th rowSpan={2} className="Inventory-Row">
                                        {inventoryDataItem.rowName}
                                    </th>
                                    <td className="Inventory-BT Inventory-BottomBorder">B</td>
                                    {inventoryDataItem && inventoryDataItem.b && typeof inventoryDataItem.b !== "number" && inventoryDataItem.b.map((boxDetail, index) =>
                                        boxDetail.boxDesc ? (
                                            <td
                                                className={`Inventory-Not-Draggable Inventory-BottomBorder`}
                                                id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                key={`inventory${index}`}
                                                style={{
                                                    background: `linear-gradient(to right, 
                                                        ${boxDetail.proppantColor}
                                                        ${boxDetail.fillPerc}%, 
                                                        #ffffff ${boxDetail.fillPerc}%)`,
                                                }}
                                            >
                                                {boxDetail.boxDesc}
                                            </td>
                                        ) : (
                                            <td
                                                key={index}
                                                id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                className="Inventory-Not-Draggable Inventory-BottomBorder"
                                            >
                                                {boxDetail.boxDesc}
                                            </td>
                                        ),
                                    )}
                                </tr>
                                <tr>
                                    <td className="Inventory-BT Inventory-TopBorder">T</td>
                                    {inventoryDataItem && inventoryDataItem.t && typeof inventoryDataItem.t !== "number" && inventoryDataItem.t.map((boxDetail, index) =>
                                        boxDetail.boxDesc ? (
                                            <td
                                                id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                className={`Inventory-Not-Draggable Inventory-TopBorder`}
                                                key={`boxdet${index}`}
                                                style={{
                                                    background: `linear-gradient(to right, 
                                                        ${boxDetail.proppantColor}
                                                        ${boxDetail.fillPerc}%, 
                                                        #ffffff ${boxDetail.fillPerc}%)`,
                                                }}
                                            >
                                                {boxDetail.boxDesc}
                                            </td>
                                        ) : (
                                            <td
                                                key={index}
                                                id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                className="Inventory-Not-Draggable Inventory-TopBorder"
                                            >
                                                {boxDetail.boxDesc}
                                            </td>
                                        ),
                                    )}
                                </tr>
                            </>
                        ))}
                    </tbody>
                </Table>

                <div className="Inventory-Legends-Container Inventory-Legends-Container-To-Print">
                    {proppantLegends.map((proppantLegend, index) => (
                        <div className="Inventory-Legend" key={index}>
                            <div className="Inventory-Legend-Color" style={{ backgroundColor: proppantLegend.color }} />
                            <div className="Inventory-Legend-Title">{proppantLegend.title}</div>
                        </div>
                    ))}
                </div>

                <div className="Inventory-Forklift-Section">
                    <i className="material-icons Inventory-ForkLift-Icon">arrow_upward</i>
                    Forklift
                </div>
            </div>
        );
    }
}
